import React, { useEffect, useState } from 'react';
import { loadSkill } from '../Skills/utilities/skillsUtils';
import IconDisplay from '../../Common/Icons/IconDisplay';

const ProjectSkillsUsed = ({ userId, skillIds = [], className = '', maxVisible }) => {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    let active = true;
    if (!userId || !Array.isArray(skillIds) || skillIds.length === 0) {
      setSkills([]);
      return undefined;
    }
    Promise.all(skillIds.map((id) => loadSkill(userId, id)))
      .then((items) => { if (active) setSkills(items.filter(Boolean)); })
      .catch(() => { if (active) setSkills([]); });
    return () => { active = false; };
  }, [userId, skillIds]);

  if (skills.length === 0) return null;

  const visibleSkills = Number.isInteger(maxVisible) ? skills.slice(0, maxVisible) : skills;
  const hiddenSkillCount = skills.length - visibleSkills.length;

  return (
    <div className={className}>
      <h6 className="mb-2">Skills used</h6>
      <div className="d-flex flex-wrap gap-2">
        {visibleSkills.map((skill) => (
          <span key={skill.id} className="badge text-bg-light border d-inline-flex align-items-center gap-1 p-2">
            <IconDisplay icon={skill.icon} userId={userId} label={skill.name} size={20} />
            {skill.name}
          </span>
        ))}
        {hiddenSkillCount > 0 ? (
          <span className="badge text-bg-light border p-2" title={`${hiddenSkillCount} more skill${hiddenSkillCount === 1 ? '' : 's'}`}>
            +{hiddenSkillCount}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default ProjectSkillsUsed;
